import React from 'react';
import Translation from "@Translation/components/Translation";
import AutoSuggest from "@Features/autosuggest/components/AutoSuggest";
import FormSuggestion from "@Form/features/stations/components/FormSuggestion";
import {useTranslation} from "@Translation/hooks/useTranslation";
import useStationLocatorAutoSuggest from "@Pages/stationLocator/hooks/useStationLocatorAutoSuggest";
import LoaderButton from "@Generic/loaders/LoaderButton";
import Notification from "@Features/notification/components/Notification";

function StationLocatorInputForm() {
    const autoSuggestModel = useStationLocatorAutoSuggest()
    const placeholder = useTranslation("form.departure.placeholder")

    return (
        <section id="stationLocatorFeature" className="gb--grid gb--grid-locator station__Locator-container">
            <div className="gb--column">
                <h3>
                    <Translation translationKey="station.locator.not_sure_about_details"/>
                </h3>
                <p>
                    <Translation translationKey="station.locator.every_journey_starts"/>
                </p>
                <AutoSuggest
                    additionalMainContainerClassName="station__Locator-feature gb--row"
                    additionalInputClassName="gb--input-standalone ui-autocomplete-input"
                    placeholder={placeholder}
                    suggestionComponent={<FormSuggestion/>}
                    autoSuggestModel={autoSuggestModel}
                >
                    <button
                        type="button"
                        className="btn btn--primary"
                    >
                        {autoSuggestModel?.selection ? (
                            <LoaderButton height="15" width="15"/>
                        ) : (
                            <Translation translationKey="station.locator.get_info"/>
                        )}
                    </button>
                </AutoSuggest>
            </div>
            <Notification>
                <h4 className="station__Locator-information-title">
                    <Translation translationKey="station.locator.important"/>
                </h4>
                <span>
                    <Translation translationKey="station.locator.finder_notification"/>
                </span>
            </Notification>
        </section>
    );
}

export default StationLocatorInputForm;